import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { LiveRegion } from '@/components/ui';
import { router } from '@/app/router';
import { browserShellEnvironment, startOfflineShell } from '@/features/offline/offlineShell';
import { usePreferences } from '@/features/preferences';
import '@/styles/global.css';

// Device preferences load in the background; defaults apply until they arrive.
void usePreferences.getState().load();
// Keep a copy of the app on this device for offline use (production builds; ADR 0013).
void startOfflineShell(browserShellEnvironment());

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing');

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
    <LiveRegion />
  </StrictMode>,
);
